import * as React from 'react'

// Render a plain string headline in two tones: the lead clause stays ink,
// and the payoff clause (everything after the first comma) flips to a
// cobalt-italic accent — the same two-tone rule the home hero uses, scaled
// down to every section heading. We use plain `italic` (not the hero's
// `display-italic`, which shrinks to 0.75em) so the payoff keeps the heading's
// own size + weight at any scale. Colour matches the hero accent (--accent-ink).
// Data-driven headlines (solutions, industries, platform sections) get the
// highlighted-payoff look without carrying markup.
//
// Falls back to the plain string when there's no comma to split on.
export function twoTone(text: string): React.ReactNode {
  const i = text.indexOf(',')
  if (i === -1 || i >= text.length - 1) return text
  const lead = text.slice(0, i + 1) // keep the comma with the lead clause
  const rest = text.slice(i + 1) // leading space + payoff clause
  return (
    <>
      {lead}
      <span className="italic text-[hsl(var(--accent-ink))]">{rest}</span>
    </>
  )
}
